module.exports = __webpack_public_path__ + "static/Tehsin@2-bb722a77f8cf507d81243886b2b3dc68.png";